import { render, staticRenderFns } from "./ModalPanel.vue?vue&type=template&id=edc20e64&scoped=true&"
import script from "./ModalPanel.vue?vue&type=script&lang=ts&"
export * from "./ModalPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPanel.vue?vue&type=style&index=0&id=edc20e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc20e64",
  null
  
)

export default component.exports